import React, { useState } from 'react';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import CaseTypeDetailModal from './CaseTypeDetailModal';
import NetteApiClient from '../../../../../Services/NetteApiClient';
import { useAppContext } from '../../../../../Services/AppContext';
import ServiceScheduleNotificationModal from '../ServiceScheduleNotification/ServiceScheduleNotificationModal';
import { getShouldBeHintDisplayed } from '../../../Services/manager.service';

interface Props {
	workplaceId: string;
	caseTypeId: string;
	isOnlyOneRoot: boolean;
}

const CaseTypeDetailButton: React.FC<Props> = ({
	caseTypeId,
	workplaceId,
	isOnlyOneRoot,
}) => {
	const [isCaseTypeDetailOpen, setIsCaseTypeDetailOpen] = useState(false);
	const [
		isServiceScheduleNotificationOpen,
		setIsServiceScheduleNotificationOpen,
	] = useState(false);
	const { redirectManagerCaseTypes } = useAppContext();

	const handleEditCaseType = () => {
		setIsCaseTypeDetailOpen(true);
	};

	const handleRedirectManagerCaseTypes = () => {
		if (redirectManagerCaseTypes) {
			NetteApiClient.get(redirectManagerCaseTypes);
		}
	};

	const handleOnSuccess = (canBookOnline: boolean) => {
		setIsCaseTypeDetailOpen(false);
		if (canBookOnline) {
			if (
				getShouldBeHintDisplayed('doNoShowServiceScheduleNotificationModal')
			) {
				setIsServiceScheduleNotificationOpen(true);
			} else {
				handleRedirectManagerCaseTypes();
			}
		} else {
			handleRedirectManagerCaseTypes();
		}
	};

	const handleOnConfirmationClose = () => {
		setIsServiceScheduleNotificationOpen(false);
		handleRedirectManagerCaseTypes();
	};

	const handleBeforeConfirmationRedirect = () => {
		setIsServiceScheduleNotificationOpen(false);
	};

	return (
		<>
			<Button
				theme={Theme.BLUE}
				title='base.shared.edit'
				onClick={handleEditCaseType}
			/>
			{isCaseTypeDetailOpen && (
				<CaseTypeDetailModal
					isOpened={isCaseTypeDetailOpen}
					onClose={() => setIsCaseTypeDetailOpen(false)}
					onRemove={() => setIsCaseTypeDetailOpen(false)}
					onSuccess={handleOnSuccess}
					caseTypeId={caseTypeId}
					workplaceId={workplaceId}
					isOnlyOneRoot={isOnlyOneRoot}
				/>
			)}
			{isServiceScheduleNotificationOpen && (
				<ServiceScheduleNotificationModal
					isOpened
					onClose={handleOnConfirmationClose}
					onRedirect={handleBeforeConfirmationRedirect}
				/>
			)}
		</>
	);
};

export default CaseTypeDetailButton;
